var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showItem)?_c('div',{staticClass:"modal-container",class:{'active': _vm.active}},[_c('div',{staticClass:"modal"},[_c('div',{staticClass:"modal-body"},[_vm._t("modal-body")],2),_c('div',{staticClass:"modal-footer"},[_vm._t("modal-footer")],2)]),_c('div',{staticClass:"modal-outside",on:{"click":_vm.close}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }